/**
 * @generated SignedSource<<f0679ce40f71ab34cf7ebdad66e003d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateProjectSchedulingShareInput = {
  filterApplied?: string | null;
  eyeApplied?: string | null;
  zoomLevel?: number | null;
  companyProjectId?: string | null;
  companyProjectGroupId?: string | null;
  initialPosition?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createProjectSchedulingShareMutation$variables = {
  input: CreateProjectSchedulingShareInput;
};
export type createProjectSchedulingShareMutation$data = {
  readonly createProjectSchedulingShare: {
    readonly projectSchedulingShare: {
      readonly url: string;
    } | null;
  } | null;
};
export type createProjectSchedulingShareMutation = {
  variables: createProjectSchedulingShareMutation$variables;
  response: createProjectSchedulingShareMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createProjectSchedulingShareMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateProjectSchedulingSharePayload",
        "kind": "LinkedField",
        "name": "createProjectSchedulingShare",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectSchedulingShare",
            "kind": "LinkedField",
            "name": "projectSchedulingShare",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createProjectSchedulingShareMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateProjectSchedulingSharePayload",
        "kind": "LinkedField",
        "name": "createProjectSchedulingShare",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectSchedulingShare",
            "kind": "LinkedField",
            "name": "projectSchedulingShare",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "23d8a7e4bf004c273437bb58de5fc0d4",
    "id": null,
    "metadata": {},
    "name": "createProjectSchedulingShareMutation",
    "operationKind": "mutation",
    "text": "mutation createProjectSchedulingShareMutation(\n  $input: CreateProjectSchedulingShareInput!\n) {\n  createProjectSchedulingShare(input: $input) {\n    projectSchedulingShare {\n      url\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "57021a58a52407dbaa879f30b3b5aac5";

export default node;
